<template>
  <el-dialog
    v-if="visible"
    visible
    :title="title"
    show-close
    width="1000px"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :custCode="custCode"
      @radio-change="(r) => (checkedRow = r)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="!checkedRow"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return { checkedRow: null }
  },
  methods: {
    close() {
      this.checkedRow = null
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    confirm() {
      if (!this.checkedRow) return
      this.$emit('confirm', this.checkedRow)
      this.close()
    },
    clearCheckboxRow() {
      this.$refs.main.clearCheckboxRow()
    },
  },
}
</script>
